import React, {useEffect, useState} from 'react';


const dicEstatus = {
  "Solicitado": {css: "is-gray", isAllowDownload: false},
  'En Proceso': {css: "is-warning", isAllowDownload: false},
  'Terminado - Falta Autorizar': {css: "is-warning", isAllowDownload: false},
  'Terminado y Publicado': {css: "is-success", isAllowDownload: true},
}
const ItemPDF = ({ese, openPDF}) => {
  
  const [att, setAtt] = useState()
  useEffect(() => {
    setAtt(dicEstatus[ese.estatus] ?? null)
  }, [ese]);
  
  if (!att) {
    return null;
  }
  
  const {css, isAllowDownload} = att;
  
  if (!isAllowDownload) {
    return (<div>
      <p>
        <span className={"tag " + css}>{ese.estatus}</span>
      </p>
      PDF no disponible
    </div>);
  }
  
  
  return (
    <div className="cursorPointer" onClick={() => openPDF(ese)}>
      <i className="fa fa-file-pdf-o  fa-3x"/>
      <span className={"tag is-success"}>{ese.estatus}</span>
    
    </div>
  );
};

export default ItemPDF